import { ColumnDef } from '@tanstack/react-table';

import TableHeader from '../common/TableHeader';
import { IPaginationTable } from '../common/interfaces/IPaginationTable';

import Table from '@/components/table/common/Table';
import { haggleEventFilterList } from '@/components/utils/constants';
import { ICollection } from '@/interfaces/api/collection/ICollection';
import { ICollectionHaggleEvent } from '@/interfaces/api/haggle-event/ICollectionHaggleEvent';
import { IHaggleWithAction } from '@/interfaces/api/haggle-event/IHaggleWithAction';

const HaggleEventTable = ({
	collection,
	paginationOption,
	columns,
	refetch,
	query,
	setQuery,
	setFilterSelected,
}: {
	collection: ICollectionHaggleEvent;
	paginationOption: IPaginationTable;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	columns: ColumnDef<IHaggleWithAction, any>[];
	refetch: () => void;
	query: string;
	setQuery: React.Dispatch<React.SetStateAction<string>>;
	setFilterSelected: React.Dispatch<React.SetStateAction<string>>;
}) => {
	const handleCollectionWithAction = (
		collection: ICollectionHaggleEvent,
	): ICollection<IHaggleWithAction> => {
		return {
			...collection,
			data: collection.data.map((item) => ({
				...item,
				action: '',
			})),
		};
	};

	return (
		<>
			<TableHeader
				title="Haggle Event List"
				counts={[
					{
						label: 'Total Haggle Events',
						value: collection.itemCount,
						dataTest: 'total-haggle-events-count',
					},
				]}
				searchConfigs={[
					{
						query: query,
						setQuery: setQuery,
						placeholder: 'Search by id',
						refetch: refetch,
					},
				]}
				filterConfig={{
					setFilterSelected: setFilterSelected,
					filterList: haggleEventFilterList,
				}}
			/>
			<div className="mx-2 pb-[2rem] bg-grey-0 border-l border-r border-b border-gray-300 rounded-xl">
				<Table<IHaggleWithAction>
					collection={handleCollectionWithAction(collection)}
					columns={columns}
					paginationSection={paginationOption}
					tableStyles={{
						tableBox: 'w-full overflow-y-auto h-fit',
						table: 'w-full',
					}}
				/>
			</div>
		</>
	);
};

export default HaggleEventTable;
